/**
 * Get Param Query
 * @param 'this.$route'
 */

import IPayloadQuery from "@/interfaces/IPayloadQuery";

function getParamQuery(route:any):IPayloadQuery {
    return {
        query: route.fullPath.split(route.path)[1]
    }
}
export default getParamQuery;